import { QuickMeetAdminFormPage } from '@/modules/meetings';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(QuickMeetAdminFormPage, {
  requiresEvery: [RouteRestrictions.AUTHENTICATION],
});
